// extracted by mini-css-extract-plugin
module.exports = {"story":"story_story__3fWUC","story__wrap":"story_story__wrap__1cp_o","story__img":"story_story__img__2nlu0"};